import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/shared/services/auth.service';
import { UserService } from 'app/shared/services/user.service';
import { passwordValidator } from 'app/shared/guards/password-equal.validator';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';



@Component({
  selector: 'ngx-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isEditBtnDisabled : boolean= false;
  isItemCodeReadOnly : boolean= true;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  showProcessingIndicatorLogo =false;
  showProcessingIndicatorSignature =false;



  companyList = [];
  validationMessages = {
    'currentPassword': { 'required': 'Current password is required' },
    'newPassword': { 'required': 'New password is required' }, 
    'confirmPassword': { 'required': 'Confirm  password is required'},    
    'passwordGroup' : {'passowrdMismatch' :'Password and Confirm password does not match'},   
  };

  formErrors = {
    'currentPassword': "",
    'newPassword': "",  
    'confirmPassword': "",
    'passwordGroup' : ""
  };

  changePwdData ={
    currentPassword : '',
    newPassword : '',
    confirmPassword : '',
    createdBy : '',
    username : ''

  }
 
  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private userService: UserService,
    private router: Router,
   ) { }

  ngOnInit(): void {

    this.initFormFields();

    this.changePasswordForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.changePasswordForm);
    });

  }



  initFormFields() : void{
    this.changePasswordForm = this.fb.group({
      currentPassword : ['',Validators.required],
      passwordGroup : this.fb.group({
        newPassword : ['',Validators.required],
        confirmPassword : ['',Validators.required],
      },{validators: passwordValidator})
     
    });
  }


  saveButtonClick(){
    var data : any;
    this.formMarkAsTouch(this.changePasswordForm);
    this.logValidationErrors(this.changePasswordForm);
    this.mapFormValuesToModel();  

          if(this.isFilledFromFields()){
                this.showProcessingIndicator = true;
                this.userService.changePassword(this.changePwdData)
                .subscribe(
                  (res) => {
                              data=res;
                             if(data.success === 0){
                                this.toastr.error('User name does not exist', 'Warning');
                                this.showProcessingIndicator = false;
                                this.router.navigate(['/login']);
                             }else if(data.success === 1){
                              this.toastr.error('Your Current Password is incorrect','Warning'); 
                              this.showProcessingIndicator = false;                              
                              }else if(data.success === 2){
                                this.toastr.success('Password has been changed successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.router.navigate(['/login']);
                                
                              }
                            },        
                  (err) =>  {
                              this.toastr.error('Failed to change password','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )                   

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 

  }

 

  logValidationErrors(group: FormGroup = this.changePasswordForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
   
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {    
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {   
        this.logValidationErrors(abstractControl);
   
      }
    });
  }

  formMarkAsTouch(group: FormGroup = this.changePasswordForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if(abstractControl && !abstractControl.valid){
        abstractControl.markAsTouched();
      }
      if (abstractControl instanceof FormGroup) {   
        this.formMarkAsTouch(abstractControl);  
      }            
    });
  }


 
  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
  }

  mapFormValuesToModel(){
    this.changePwdData.currentPassword=this.changePasswordForm.value.currentPassword;
    this.changePwdData.newPassword=this.changePasswordForm.get('passwordGroup.newPassword').value;
    this.changePwdData.confirmPassword=this.changePasswordForm.get('passwordGroup.confirmPassword').value;
    this.changePwdData.username = this.authService.getUserLoggedIn();
    this.changePwdData.createdBy = this.authService.getUserLoggedIn();

  }



}
